export { default as popupMagazineAuthorItem } from '@handlebars/popup-magazine-author-item.hbs';
export { default as popupMagazineJoin } from '@handlebars/popup-magazine-join.hbs';
export { default as popupMagazineJoinItem } from '@handlebars/popup-magazine-join-item.hbs';
export { default as popupMagazineRequestItem } from '@handlebars/popup-magazine-request-item.hbs';
export { default as popupUserList } from '@handlebars/popup-user-list.hbs';
